import { render, staticRenderFns } from "./DefaultActivitySettings.vue?vue&type=template&id=b5204dcc"
import script from "./DefaultActivitySettings.vue?vue&type=script&lang=js"
export * from "./DefaultActivitySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports